import React from 'react';
import './style.scss';
import Icon from '../../../../components/Icon/Icon';
import { Link } from 'react-router-dom';
import MetaInfo from './MetaInfo/MetaInfo';
import imgHero from './i/root_beer_hero.jpg';
import imgHeroMobile from './i/mobile/root_beer_hero.jpg';
import arrow from '../../../../assets/images/hero-arrow.png';
import rootbeerSvg from './i/svg/root_beer_stamp.svg';
import rootbeerSvgFr from './i/svg/root_beer_stamp_fr.svg';
import SliderWrap from '../../../../components/SliderWrap/SliderWrap';
import slide1 from './i/carousel_rootbeer_1.jpg';
import slide2 from './i/carousel_rootbeer_2.jpg';
import slide3 from './i/carousel_rootbeer_3.jpg';
import slide4 from './i/carousel_rootbeer_4.jpg';
import slide5 from './i/carousel_rootbeer_5.jpg';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const RootBeer = (props) => {

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food-pages rootbeer">

                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="Root beer" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="Root beer" />
                    }
                </div>

                <div className="copy-block">
                    {/* <h1><span><span className="line"></span> Beef <span className="line"></span></span>something or other</h1> */}
                    {props.lang === 'en' ? <img className="img-svg" src={rootbeerSvg} alt={"chicken"} /> : <img className="img-svg" src={rootbeerSvgFr} alt={"chicken"} />}
                    {props.lang === 'en' && <p>A&W Root Beer® is made with natural cane sugar and all-natural flavours. So it’s a more natural way to treat yourself.</p>}
                    {props.lang === 'fr' && <p>La Root Beer A&W™ est faite avec du sucre de canne naturel et des saveurs naturelles. Pour vous faire plaisir de façon toute naturelle.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

            <div className="where-block">
                            
                {props.lang !== 'fr' ?
                    <>
                        <h2>Raising a glass to&nbsp;  
                            <span>natural ingredients</span>
                        </h2>
                    </>
                    :
                    <>
                        <h2>On lève notre bock aux&nbsp;  
                            <span>ingrédients naturels.</span>
                        </h2>
                    </>
                }
            </div>

            <SliderWrap {...props}>
                <div key="1" className="item">
                    <div className="itemcol">
                        <img src={slide1} className="" alt=""  /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>NATURAL CANE SUGAR</h3>
                                        <p>Harvested from the sugarcane plant and identified by its caramel colour, natural cane sugar provides a fruity sweetness and floral aroma.</p>
                                    </>
                                :
                                    <>
                                        <h3>SUCRE DE CANNE NATUREL</h3>
                                        <p>Le sucre de canne naturel est extrait de la canne à sucre et se caractérise par sa couleur caramel, sa douceur fruitée et son arôme floral.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="2" className="item">
                    <div className="itemcol">
                        <img src={slide2} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>BIRCH BARK</h3>
                                        <p>Light, yet complex, birch bark brings a subtle earthiness to the smooth, delicious taste, offering a delicate, almost minty flavour.</p>
                                    </>
                                :
                                    <>
                                        <h3>ÉCORCE DE BOULEAU</h3>
                                        <p>Légères, fraîches et complexes, les saveurs de l’écorce de bouleau apportent un subtil côté terreux et de délicates notes de menthe.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="3" className="item">
                    <div className="itemcol">
                        <img src={slide3} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>SARSAPARILLA ROOT</h3>
                                        <p>Sarsaparilla is a plant with long vines and edible roots that lends distinct notes of vanilla, caramel and wintergreen.</p>
                                    </>
                                :
                                    <>
                                        <h3>RACINE DE SALSEPAREILLE</h3>
                                        <p>La salsepareille est une plante qui produit des fruits en grappe et dont les racines sont comestibles. Ces dernières présentent des notes distinctes de vanille, de caramel et de thé des bois.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="4" className="item">
                    <div className="itemcol">
                        <img src={slide4} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>LICORICE ROOT</h3>
                                        <p>Licorice creates a richness of flavour in every sip with slightly bitter, sweet and spicy undertones.</p>
                                    </>
                                :
                                    <>
                                        <h3>RÉGLISSE</h3>
                                        <p>La réglisse naturelle crée à chaque gorgée une grande richesse aromatique avec son goût légèrement amer, sucré et épicé.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="5" className="item">
                    <div className="itemcol">
                        <img src={slide5} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>ANISE</h3>
                                        <p>An aromatic spice delivering pleasant characteristics of fennel and tarragon, anise has been enjoyed as far back as the ancient Egyptians.</p>
                                    </>
                                :
                                    <>
                                        <h3>ANIS</h3>
                                        <p>Dégageant d’agréables arômes de fenouil et d’estragon, l’anis est utilisé comme épice aromatique depuis l’Égypte ancienne.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>

            </SliderWrap>

            <div className="blockwrap our-food faq-block rootbeer">
            
                <Link  className="find-aw"  to={`/${props.lang}/faq/beverages`}>
                    {props.lang !== 'fr' ? 
                        <><span>Root Beer</span> FAQ<Icon type=" gt-inverted" /></>
                        :
                        <><span>FAQ sur notre</span> Root Beer<Icon type=" gt-inverted" /></>
                    }
                </Link>

            </div>

            <IngredientsSlider currentPage="rootbeer" {...props} />
            <MobileOrderBanner {...props} />
                        
        </>

    )
}
export default RootBeer;